import { jwtDecode } from 'jwt-decode';
import { AUTH_TOKEN } from 'shared/constants/commmon';

export const getAuthUserData = (): string | null => {
  const data = localStorage.getItem(AUTH_TOKEN);
  return data ? JSON.parse(data) : null;
};

export const setAuthUserData = (token: string): void => {
  try {
    localStorage.setItem(AUTH_TOKEN, JSON.stringify(token));
  } catch (e) {
    // опционально: лог / sentry
  }
};

export const setAuthBitrixUserData = (data: string): void => {
  localStorage.setItem(AUTH_TOKEN, JSON.stringify(data));
};

export const removeAuthUserData = (): void => {
  localStorage.removeItem(AUTH_TOKEN);
};

export const checkTokenExpire = (token: string): boolean => {
  try {
    const { exp } = jwtDecode(token);
    const currentTime = new Date().getTime() / 1000;

    if (exp && currentTime > exp) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};
